import React from "react";
import Icon from "./Icon";
export default function Download(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M20 14V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9L11 14L16 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14V2"
  }));
}
Download.displayname = "Download";
//# sourceMappingURL=Download.js.map